import React from "react";
import "./footer.css";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useContext } from "react";
import { ThemeContext } from "../context";

export const Footer = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="f">
      <div className="f-wrapper">
        <h1 className="logo">
          dg <span>.</span>
        </h1>
      </div>
      <p className="f-p">
        <b>What’s your story? </b> &nbsp; Get in touch. Always available for
        freelancing if the right project comes along me.
      </p>
      <div className="media-wrapper">
        <button>
          <a
            href="mailto:goda.d@northeastern.edu"
            target="_blank"
            rel="noreferrer"
          >
            <MdEmail size="lg" />
          </a>
        </button>
        <button>
          <a
            href="https://github.com/DrishtiGoda"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub size="lg" />
          </a>
        </button>
        <button>
          <a
            href="https://www.linkedin.com/in/drishtigoda/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn size="lg" />
          </a>
        </button>
      </div>
      <div
        className="copyright"
        style={{
          backgroundColor: darkMode ? "white" : "#0F152F",
          color: darkMode ? "black" : "white",
        }}
      >
        {/* <p>Copyright &copy; 2022 All rights reserved</p> */}
        <p>Developed and designed with love ❤️ Drishti Goda</p>
      </div>
    </div>
  );
};
